import { gql } from '@apollo/client/core';
export const CONNECTION_METADATA_FIELDS = gql `
  fragment ConnectionMetadataFields on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`;
//# sourceMappingURL=Api.js.map